module.exports = __webpack_public_path__ + "static/img/far1_active.a7897d7a.png";